import { BaseLayout } from "@components/general/base_layout";
import { Header } from "@components/general/header";
import PreloadLogo from "@assets/images/logo-sipiat.jpg";
import { FaExclamationTriangle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <BaseLayout>
      <div className="bg-semi-circle"></div>
      <Header>
        <div className="page-title">
          <div className="tw-pt-24 tw-text-center">
            <img
              src={PreloadLogo}
              alt="Logo Ponpes"
              className="tw-w-3/5 tw-rounded-sm tw-mb-10"
            />
          </div>
        </div>
      </Header>
      <div className="tw-mt-12 tw-py-12 tw-mx-4 tw-text-center tw-bg-other-100 tw-rounded-lg card-body">
        <div className="">
          <div>
            <FaExclamationTriangle className="tw-text-red-500 tw-text-8xl" />
          </div>
          <div className="tw-font-bold tw-text-6xl tw-pt-3 tw-pb-2">404</div>
          <div className="tw-text-uppercase tw-pb-3 tw-text-lg tw-font-medium">
            Halaman tidak ditemukan
          </div>
          <div
            className="tw-mx-auto tw-text-[13px]"
            style={{ maxWidth: "300px", width: "85%", lineHeight: "1.5" }}
          >
            Halaman yang kamu cari tidak bisa ditemukan. Kembali ke Beranda?
          </div>
          <div className="text-center">
            <Button
              className="tw-mt-12 tw-h-9 tw-w-full tw-mt-1 bg-gradient tw-text-other-100 focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
              htmlType="button"
              onClick={() => navigate("/")}
            >
              Kembali
            </Button>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default NotFoundPage;
